import * as React from 'react';

import { Tooltip } from '@opendoor/bricks/complex';
import { Box, Flex, Text } from '@opendoor/bricks/core';

interface IHeaderProps {
  title: string;
  subtitle: string;
  titleRef: React.RefObject<HTMLHeadingElement>;
  currentSlug?: string;
  tooltip?: string;
}

const Header: React.FC<IHeaderProps> = ({ title, subtitle, titleRef, currentSlug, tooltip }) => {
  return (
    <Box>
      <Flex
        flexDirection="column"
        maxWidth={['327px', null, '560px']}
        width={['327px', null, '560px']}
        mb={[4, 9]}
        mt={[0, null, 6]}
      >
        {title && (
          <Box ref={titleRef}>
            <Text
              size="170"
              fontWeight="medium"
              aria-live={currentSlug !== 'overview' ? 'polite' : undefined}
              tabIndex={-1}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </Box>
        )}
        {subtitle && (
          <Flex flexDirection="row">
            <Text
              fontSize={['s0', 's1']}
              mt={5}
              color="neutrals100"
              dangerouslySetInnerHTML={{ __html: subtitle }}
            />
            {tooltip && (
              <Flex display="inline-block" position="relative" top="5px" left="1px">
                <Tooltip
                  label={'Additional information for answering this question'}
                  analyticsName={`reception-fe-${subtitle
                    .toLowerCase()
                    .split(' ')
                    .join('-')}-question-tooltip`}
                  height="0px"
                  popupDirection="top"
                >
                  {tooltip}
                </Tooltip>
              </Flex>
            )}
          </Flex>
        )}
      </Flex>
    </Box>
  );
};

export default Header;
